import styled, { css } from "styled-components"
import { NeutralTextLink } from "../../../ui/components/link/link.component"
import { subMenuGeneralStyles } from "../navigation-list/navigation-list.styled"

export const SubMenuLink = styled(NeutralTextLink)`
  padding: 10px;
  font-size: ${12 / 16}rem;
  text-decoration: none;
  text-transform: initial;
  font-family: ${({ theme }) => theme.font.display};
  color: ${({ theme }) => theme.color.textDisplay};

  &:hover[href] {
    color: ${({ theme }) => theme.color.text};
  }

  &.active,
  &.active:hover[href] {
    color: ${({ theme }) => theme.color.link};
  }

  @media (min-width: 460px) {
    padding: 0 25px;
  }
`

export const SubMenuContainer = styled.nav<{ hovered: boolean }>`
  ${subMenuGeneralStyles};
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${({ hovered }) =>
    hovered &&
    css`
      & > ${SubMenuLink} {
        opacity: 0.5;
        transition: opacity 0.2s ease-in-out;
        &:hover {
          opacity: 1;
        }
      }
    `}
`

export const SubmenuWrapper = styled.div<{ active?: boolean }>`
  display: ${({ active }) => (active ? "flex" : "block")};
  flex-direction: column;
  align-items: left;
  padding: 23px 8px;
  width: ${({ active }) => active && "180px"};

  ${SubMenuLink} {
    padding: ${({ active }) => active && "0px"};
  }
`

export const Category = styled.div`
  color: #737373;
  font-size: ${12 / 16}rem;
  padding-bottom: 10px;
  font-weight: 500;
  letter-spacing: 2px;
  text-decoration: none;
  line-height: 12px;
  height: 12px;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.font.display};
`
